(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section/assets/javascripts/casino-section-scrollable.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section/assets/javascripts/casino-section-scrollable.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useEffect = _React.useEffect;
const CasinoSectionHeader = svs.components.casino_react.casinoSection.CasinoSectionHeader;
const CasinoGridScrollable = svs.components.casino_react.CasinoGridScrollable;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  IconButton = _svs$ui.ReactIconButton;
const Actions = _ref => {
  let ActionButtons = _ref.ActionButtons,
    scrollableElement = _ref.scrollableElement,
    scrollState = _ref.scrollState;
  const isLargeScreen = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  return React.createElement(React.Fragment, null, ActionButtons && React.createElement(ActionButtons, null), isLargeScreen && React.createElement("div", {
    className: "casino-section-action__button-wrapper"
  }, React.createElement(IconButton, {
    "aria-label": "G\xE5 v\xE4nster",
    disabled: scrollState.leftDisabled,
    onClick: () => scrollableElement.scrollBy({
      left: -1,
      behavior: 'smooth'
    }),
    title: "G\xE5 v\xE4nster"
  }, React.createElement(Icon, {
    icon: "menu-left",
    size: "300"
  })), React.createElement(IconButton, {
    "aria-label": "G\xE5 h\xF6ger",
    disabled: scrollState.rightDisabled,
    onClick: () => scrollableElement.scrollBy({
      left: 1,
      behavior: 'smooth'
    }),
    title: "G\xE5 h\xF6ger"
  }, React.createElement(Icon, {
    icon: "menu-right",
    size: "300"
  }))));
};
const pixelErrorMargin = 6;
const setScrollStateUtil = (scrollElement, setScrollState) => {
  const maxScroll = scrollElement.scrollWidth - scrollElement.clientWidth;
  const scrollMaxLeft = scrollElement.scrollLeft === 0;
  const scrollPositionIsAtMaxPosition = scrollElement.scrollWidth === scrollElement.clientWidth;
  const scrollMaxRight = scrollElement.scrollLeft + pixelErrorMargin >= maxScroll;
  setScrollState({
    leftDisabled: scrollMaxLeft || scrollPositionIsAtMaxPosition,
    rightDisabled: scrollMaxRight || scrollPositionIsAtMaxPosition
  });
};
const CasinoSectionScrollable = _ref2 => {
  let ActionButtons = _ref2.ActionButtons,
    items = _ref2.items,
    title = _ref2.title;
  const isListEmpty = !(items !== null && items !== void 0 && items.length);
  const scrollableElement = useRef(null);
  const _useState = useState({
      leftDisabled: true,
      rightDisabled: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    scrollState = _useState2[0],
    setScrollState = _useState2[1];
  useEffect(() => {
    const scrollableEl = scrollableElement.current;
    if (scrollableEl) {
      setScrollStateUtil(scrollableEl, setScrollState); 

      scrollableEl.addEventListener('scroll', e => {
        setScrollStateUtil(e.currentTarget, setScrollState);
      });
      window.addEventListener('resize', () => {
        setScrollStateUtil(scrollableEl, setScrollState);
      });
    }
    return () => {
      if (scrollableEl) {
        scrollableEl.removeEventListener('scroll', setScrollState);
        window.removeEventListener('resize', setScrollState);
      }
    };
  }, [scrollableElement]);
  if (isListEmpty) {
    return null;
  }
  return React.createElement("section", {
    className: "casino-section"
  }, React.createElement(CasinoSectionHeader, {
    ActionButtons: () => React.createElement(Actions, {
      ActionButtons: ActionButtons,
      scrollableElement: scrollableElement === null || scrollableElement === void 0 ? void 0 : scrollableElement.current,
      scrollState: scrollState
    }),
    title: title
  }), React.createElement("div", {
    className: "casino-section__scrollable"
  }, React.createElement(CasinoGridScrollable, {
    items: items,
    ref: scrollableElement
  })));
};
setGlobal('svs.components.casino_react.casinoSection.CasinoSectionScrollable', CasinoSectionScrollable);

 })(window);